import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { EncryptionUtil } from '../services/encryption-util';
import { environment } from '../../environments/environment';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEventType, HttpResponse } from '@angular/common/http';

@Injectable()
export class BsSecureServiceCallInterceptor implements HttpInterceptor {
  constructor(private encryptionUtil: EncryptionUtil) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    this.logEvent('request', req);
    const pass = this.encryptionUtil.getRandomPassword();
    if (!this.noNeedEncryptReq(req)) {
      req = this.generateEncryptedRequest(req, pass);
    }

    return next.handle(req).pipe(
      map((event) => {
        if (event.type === HttpEventType.Response) {
          event = this.generateDecryptedResponse(event, pass);
          this.logEvent('response', event);
        }
        return event;
      }));
  }

  private isVU(req: HttpRequest<any>): boolean {
    const urls = [
      environment.vuParams.vuUrl
    ];
    return urls.some((url) => req.url.includes(url));
  }

  private noNeedEncryptReq(req: any): boolean {
    const urls = [
      environment.flagr.url,
      environment.staticScripts.staticAssets,
      environment.bankingServer.base_path.omni1,
      environment.bankingServer.base_path.omni2
    ];
    return urls.some((url) => req.url.includes(url));
  }

  private generateEncryptedRequest(req: HttpRequest<any>, pass: string): HttpRequest<any> {
    const isPep = [environment.pepParams.url].some((url) => req.url.includes(url));
    const publicKey = isPep ? environment.bsPubKey : this.isVU(req) ? environment.vuPubKey : environment.pubKey;

    return req.clone({
      body: this.encryptionUtil.createSecureRequest(JSON.stringify(req.body), pass, publicKey)
    });
  }

  private generateDecryptedResponse(res: HttpResponse<any>, pass: string): HttpResponse<any> {
    if (environment.isStubby || this.noNeedEncryptReq(res)) {
      return res;
    }
    const bodyPass = environment.should_encrypt === false && res.body.p;
    const password = bodyPass ? res.body.p : pass;
    const decryptBody = this.encryptionUtil.resolveSecureResponse(res.body, password);

    return res.clone({
      body: JSON.parse(decryptBody)
    });
  }

  private logEvent(type: string, payload: any): void {
    if (!environment.production) {
      console.log(type, payload.url, { payload });
    }
  }
}
